<template>
  <div class="reportTable">
    <section ref="print">
      <div class="title">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>
              {{ this.$moment(this.startDate).format('YYYY-MM-DD') }}
            </span>
            <span v-if="$parent.endTimeShow">
              至{{ this.$moment(this.endDate).format('YYYY-MM-DD') }}
            </span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="report">
        <table style="border-collapse: collapse" align="center" width="100%">
          <div style="border-top: 1px solid #000" class="reportTitle">
            <span>账号</span>
            <span>客户名称</span>
            <span>联系人</span>
            <span>联系人电话</span>
            <span style="text-align:right">信用额</span>
            <span style="text-align:right">欠款结余</span>
          </div>
          <div v-for="item in List" class="Item">
            <span>{{ item.accNo }}</span>
            <span>{{ item.customerName }}</span>
            <span>{{ item.linkName }}</span>
            <span>{{ item.linkPhone }}</span>
            <span style="text-align:right">{{
              $parent.curreny(item.creditLimit)
            }}</span>
            <span style="text-align:right">{{
              $parent.curreny(item.qkjy)
            }}</span>
          </div>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from '@/api/api1.js'
export default {
  data() {
    return {
      List: [],
      nowday: '',
      nowtime: '',
      startDate: '',
      endDate: '',
    }
  },
  created() {
    this.$parent.closeshow()
    this.$parent.bbmc = 'A02应收单位欠款结余报表'
    this.$store.state.preArrivalName = this.$parent.bbmc
    this.$parent.startDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.queryDate = new Date()
    this.date = this.$moment(this.queryDate).format('YYYY-MM-DD HH:mm:ss')
    this.$parent.startTimeShow = true
    this.$parent.showXsy = true
    this.$parent.chaxunvib = true
    this.getData()
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print)
    },
    doserach() {
      this.getData()
    },
    getData() {
      this.nowday = this.$moment(new Date()).format('YYYY-MM-DD')
      this.nowtime = this.$moment(new Date()).format('HH:mm:ss')
      this.startDate = this.$parent.startDate
      this.endDate = this.$parent.endDate
      let that = this
      let parms = {
        queryDate: this.$parent.startDate,
        saleId: this.$parent.xsy,
      }
      let loadingInstance = this.$loading({ text: '正在查询...' })
      postRequest('/tCustomerReport/getListA02', parms).then(res => {
        this.$nextTick(() => {
          loadingInstance.close()
        }) //不回调
        if (res.status == 200) {
          res.data.forEach(item => {
            item.qkjy = item.amount - item.useAmount
          })
          this.List = res.data
          this.$store.state.preArrivalList = res.data
          this.$parent.datacount = res.data.length
        } else {
          this.$mymessage({
            content: res.code,
            type: 'error',
            time: 3000,
            hasClose: true,
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.reportTable {
  height: 100%;
  overflow: scroll;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 40px;
  height: 62px;
}
.title > ul {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
ul li {
  list-style: none;
  font-size: 14px;
}
.title-label {
  font-size: 14px;
  margin-bottom: 20px;
}
.formTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  line-height: 25px;
  margin-bottom: 10px;
  font-size: 14px;
}
.formTitle > li {
  width: 8%;
  text-align: center;
}

.total {
  font-size: 14px;
  font-weight: bold;
}
.total > div {
  padding-left: 220px;
}
.total > div > span {
  margin-right: 50px;
}
.hotelTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
}
.hotelTitle > li {
  width: 100%;
}
.hotelName {
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 30px;
  border-bottom: 1px solid #000;
}
.HotelList {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-top: 1px solid #000;
}

.inStoreGuestTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* border: 1px solid #000; */
  line-height: 25px;
  /* margin-bottom: 10px; */
}
.inStoreGuestTitle > li {
  border: 1px solid #000;
  width: 12em;
  text-align: center;
}
.inStoreGuestTotal {
  display: flex;
  flex-direction: row;
  line-height: 25px;
}
.inStoreGuestTotal > li {
  width: 12em;
  text-align: center;
  border: 1px solid #000;
}
.report {
  margin-bottom: 80px;
}

table th {
  text-align: center;
  font-weight: normal;
}
table td {
  text-align: center;
}
.trTitle {
  font-weight: bolder;
  border-bottom: 1px solid #000;
}
.trType {
  font-weight: bolder;
}
.trType .tdFlex > div {
  display: flex;
}
td .topDeshed {
  border-top: 2px dashed #000;
  flex: 1;
  transform: translateY(9px);
}
.reportTitle {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}
.reportTitle > span {
  display: inline-block;
  width: 15%;
  text-align: center;
  /* background: cornflowerblue; */
  /* margin-right: 5%; */
}
.Item {
  display: flex;
  justify-content: space-between;
  line-height: 24px;
}
.Item > span {
  display: inline-block;
  width: 15%;
  text-align: center;
  /* background: cornflowerblue; */
  /* margin-right: 5%; */
}
</style>
